import { useTranslate } from '@/shared/lib'

const useModel = () => {
  const { trs } = useTranslate()

  /* Список временных интервалов */
  const timeIntervals = [
    { title: trs('itf.minutes', { num: 5 }), value: 5 },
    { title: trs('itf.minutes', { num: 10 }), value: 10 },
    { title: trs('itf.minutes', { num: 30 }), value: 30 },
    { title: trs('itf.minutes', { num: 60 }), value: 60 },
  ]

  return {
    timeIntervals,
  }
}

export default useModel
